export function base64ToBlob(base64, mime) {
    const byteChars = atob(base64);
    const byteArrays = [];

    for (let i = 0; i < byteChars.length; i += 512) {
        const slice = byteChars.slice(i, i + 512);
        const byteNumbers = new Array(slice.length);
        for (let j = 0; j < slice.length; j++) {
            byteNumbers[j] = slice.charCodeAt(j);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mime });
}

export const handleDownloadAttachment = async (filePath) => {
    const res = await fetch(filePath, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url);

}

export const handleDownloadBase64 = async (filePath) => {
    const [header, base64] = filePath.split(",");
    const mime = header.match(/:(.*?);/)[1];

    const blob = base64ToBlob(base64, mime);
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, "_blank");
}